module.exports = __webpack_public_path__ + "img/detailpost.1b2eee79.png";